import React from "react";
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button } from "@mui/material";
import { Add as AddIcon, Search as SearchIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface SearchAndFiltersProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  onCreateNew: () => void;
  creating: boolean;
}

const SearchAndFilters: React.FC<SearchAndFiltersProps> = ({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  onCreateNew,
  creating,
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, md: 5 }}>
        <TextField
          size="small"
          fullWidth
          placeholder={t("deepResearch.actions.search")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: <SearchIcon sx={{ mr: 1, color: "text.secondary" }} />,
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <FormControl fullWidth>
          <InputLabel size="small">{t("deepResearch.list.statusFilter")}</InputLabel>
          <Select
            value={statusFilter}
            size="small"
            label={t("deepResearch.list.statusFilter")}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <MenuItem value="">{t("deepResearch.status.all")}</MenuItem>
            <MenuItem value="analyzing">{t("deepResearch.status.analyzing")}</MenuItem>
            <MenuItem value="planning">{t("deepResearch.status.planning")}</MenuItem>
            <MenuItem value="plan_pending">{t("deepResearch.status.planPending")}</MenuItem>
            <MenuItem value="researching">{t("deepResearch.status.researching")}</MenuItem>
            <MenuItem value="completed">{t("deepResearch.status.completed")}</MenuItem>
            <MenuItem value="error">{t("deepResearch.status.error")}</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <Button
          disableElevation
          fullWidth
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreateNew}
          sx={{ height: 40 }}
          disabled={creating}
        >
          {t("deepResearch.actions.newResearch")}
        </Button>
      </Grid>
    </Grid>
  );
};

export default SearchAndFilters;
